<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="k-rtl">

      <div class="row px-3 md-pt-0 md-px-0">
        <div class="col-lg-3">
          <div class="widget home style1">
            <div class="row">
              <div class="col-4 text-center">
                <div class="main-card__icon-container">
                  <i class="fas fa-users fa-3x"></i>
                </div>
              </div>
              <div class="col-8 text-right">
                <span> تعداد کل رانندگان </span>
                <h2 class="font-bold main-card__data">
                  {{ adminDashboard.total ? adminDashboard.total : 0 }}
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="widget home style1">
            <div class="row">
              <div class="col-4">
                <div class="main-card__icon-container">
                  <i class="far fa-clock fa-3x"></i>
                </div>
              </div>
              <div class="col-8 text-right">
                <span> تعداد رانندگان امروز </span>
                <small>
                  {{
                    adminDashboard.today && adminDashboard.today.date
                      ? $getJalaliDateNewFormat(adminDashboard.today.date)
                      : "-"
                  }}
                </small>
                <h2 class="font-bold main-card__data">
                  {{
                    adminDashboard.today && adminDashboard.today.count
                      ? adminDashboard.today.count
                      : 0
                  }}
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="widget home style1">
            <div class="row">
              <div class="col-4">
                <div class="main-card__icon-container">
                  <i class="fas fa-history fa-3x"></i>
                </div>
              </div>
              <div class="col-8 text-right">
                <span> تعداد رانندگان دیروز </span>
                <small>
                  {{
                    adminDashboard.yesterday && adminDashboard.yesterday.date
                      ? $getJalaliDateNewFormat(adminDashboard.yesterday.date)
                      : "-"
                  }}
                </small>
                <h2 class="font-bold main-card__data">
                  {{
                    adminDashboard.yesterday && adminDashboard.yesterday.count
                      ? adminDashboard.yesterday.count
                      : 0
                  }}
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="widget home style1">
            <div class="row">
              <div class="col-4">
                <div class="main-card__icon-container">
                  <i class="fas fa-history fa-3x"></i>
                </div>
              </div>
              <div class="col-8 text-right">
                <span> تعداد رانندگان هفته قبل </span>
                <small>
                  {{
                    adminDashboard.last_week
                      ? lastWeekDate(adminDashboard)
                      : "-"
                  }}
                </small>
                <h2 class="font-bold main-card__data">
                  {{
                    adminDashboard.last_week && adminDashboard.last_week.count
                      ? adminDashboard.last_week.count
                      : 0
                  }}
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
     
      <div class="row px-3 md-pt-0 md-px-0 dashboard-cards">

        <div
          v-for="item in dashboardItems"
          :key="item.key"
          class="col-lg-3 col-md-4 col-sm-6 mb-3"
        >
          <div
            class="widget home style1 dashboard-card"
            :class="{
              'active-card': activeItem && activeItem.key === item.key
            }"
            @click="selectDashboardItem(item)"
          >
            <div class="dashboard-card-content">

              <!-- آیکون -->
              <div class="dashboard-card-icon">
                <i :class="item.icon"></i>
              </div>

              <!-- محتوا -->
              <div class="dashboard-card-info">

                <span class="dashboard-card-title">
                  {{ item.title }}
                </span>

                <small
                  v-if="item.showDate && item.date"
                  class="dashboard-card-date"
                >
                  {{ item.date }}
                </small>

                <div class="dashboard-card-value">
                  {{ getItemValue(item) }}
                </div>

                <small
                  v-if="item.type === 'salon'"
                  class="dashboard-card-subtitle"
                >
                  {{ item.requests_count || 0 }} / {{ item.total_count || 0 }}
                </small>

              </div>

            </div>
          </div>
        </div>

      </div>

      <bita-ibox v-if="showChart">

        <template slot="header">
          <div class="chart-header">

            <div>
              <h5 class="chart-title">
                {{ chartTitle }}
              </h5>

              <small
                v-if="activeItem && activeItem.type === 'salon'"
                class="chart-subtitle"
              >
                آمار هفته گذشته
              </small>
            </div>

            <div
              v-if="loadingChart"
              class="chart-loading"
            >
              در حال دریافت اطلاعات...
            </div>

          </div>
        </template>

        <div slot="body">

          <div class="k-rtl">

            <chart
              v-if="chart.length > 0 && !loadingChart"
              :key="chartKey"
              :chart-data="chart"
              :y-title="chartYTitle"
              :category="chartCategory"
              :value="chartValue"
              height="450px"
            />

            <div
              v-else-if="!loadingChart"
              class="empty-chart"
            >
              <i class="fas fa-chart-bar"></i>

              <p>
                داده‌ای برای نمایش وجود ندارد
              </p>
            </div>

          </div>

        </div>

      </bita-ibox>

    </div>
  </div>
</template>


<script>
import Chart from "../../../components/template/chart/AmColumnWithRoutatedSeries.vue";

export default {
  name: "AdminDashboard",

  components: {
    Chart,
  },

  data() {
    return {
      // داده‌های بخش اصلی (بدون تغییر)
      adminDashboard: {
        total: 0,
        today: {},
        yesterday: {},
        last_week: {},

        last_tickets: [],
        last_cancelled_tickets: [],
        last_reserve_requests: [],
        last_bazargah_requests: [],
      },
      salons: [],
      activeItem: null,
      chart: [],
      chartKey: 0,
      loadingChart: false,
      defaultChartType: "tickets",
    };
  },


  computed: {
    dashboardItems() {

      const items = [
        {
          key: "tickets",
          type: "admin",
          chartType: "tickets",

          title: "نوبت‌های خریداری شده امروز",

          icon: "fas fa-ticket-alt fa-2x",

          showDate: false,
        },

        {
          key: "cancelled",
          type: "admin",
          chartType: "cancelled",

          title: "نوبت‌های باطل شده امروز",

          icon: "fas fa-ban fa-2x",

          showDate: false,
        },

        {
          key: "reserve",
          type: "admin",
          chartType: "reserve",

          title: "رزروهای بار امروز",

          icon: "fas fa-calendar-check fa-2x",

          showDate: false,
        },

        {
          key: "bazargah",
          type: "admin",
          chartType: "bazargah",

          title: "درخواست‌های سالن صفر امروز",

          icon: "fas fa-store-alt fa-2x",

          showDate: false,
        },
      ];

      this.salons.forEach((salon) => {

        items.push({

          key: `salon-${salon.salon_id}`,

          type: "salon",

          salon_id: salon.salon_id,

          title: salon.salon_name,

          icon: "fas fa-warehouse fa-2x",

          requests_count: salon.requests_count,

          total_count: salon.total_count,

          showDate: false,
        });

      });


      return items;
    },

    chartTitle() {

      if (!this.activeItem) {
        return "آمار";
      }


      if (this.activeItem.type === "salon") {

        return `نمودار اعلام بار - ${this.activeItem.title}`;

      }


      const titles = {
  tickets:   "نمودار نوبت‌های خریداری شده امروز به تفکیک سالن",
  cancelled: "نمودار نوبت‌های باطل شده امروز به تفکیک سالن",
  reserve:   "نمودار رزروهای بار در هفته گذشته",
  bazargah:  "نمودار درخواست‌های سالن صفر در هفته گذشته",
};


      return titles[this.activeItem.chartType] || "آمار";
    },

    chartYTitle() {

      if (!this.activeItem) {
        return "تعداد";
      }


      if (this.activeItem.type === "salon") {

        return "تعداد اعلام بار";

      }


      const titles = {
  tickets:   "تعداد نوبت‌های خریداری شده",
  cancelled: "تعداد نوبت‌های باطل شده",
  reserve:   "تعداد رزروهای بار",
  bazargah:  "تعداد درخواست‌های سالن صفر",
};


      return titles[this.activeItem.chartType] || "تعداد";
    },

    chartCategory() {
  if (!this.activeItem) return "created_at";
  if (this.activeItem.type === "salon") return "date";

  // برای دو آیتم امروز، محور X نام سالن است
  if (
    this.activeItem.chartType === "tickets" ||
    this.activeItem.chartType === "cancelled"
  ) {
    return "salon_name";
  }

  return "created_at";
},

    chartValue() {
  if (!this.activeItem) return "count";
  if (this.activeItem.type === "salon") return "requests_count";
  return "count";
},

    showChart() {

      return !!this.activeItem;
    },
  },


  mounted() {

    this.$setLayout("app-layout");

    this.initializeDashboard();

  },


  methods: {
    async initializeDashboard() {

      try {

        await Promise.all([

          this.getAdminDashboard(),

          this.fetchSalons(),

        ]);

        const defaultItem = this.dashboardItems.find(
          (item) => item.key === this.defaultChartType
        );


        if (defaultItem) {

          this.selectDashboardItem(defaultItem);

        }

      } catch (error) {

        console.error(
          "Dashboard initialization error:",
          error
        );

      }
    },
    async getAdminDashboard() {

      try {

        const res = await this.$persistClient(
          "get",
          "dashboard/admin"
        );


        this.adminDashboard =
          res.data.data || {

            total: 0,

            today: {},

            yesterday: {},

            last_week: {},

            last_tickets: [],

            last_cancelled_tickets: [],

            last_reserve_requests: [],

            last_bazargah_requests: [],
          };


      } catch (error) {

        console.error(
          "getAdminDashboard error:",
          error
        );

      }
    },
    async fetchSalons() {

      try {

        const res = await this.$persistClient(
          "get",
          "requests/top-salons"
        );


        this.salons =
          res.data.data || [];


      } catch (error) {

        console.error(
          "fetchSalons error:",
          error
        );


        this.salons = [];
      }
    },

    selectDashboardItem(item) {

      if (!item) {
        return;
      }


      this.activeItem = item;
      if (item.type === "salon") {

        this.fetchSalonChart(item.salon_id);

      } else {

        this.loadAdminChart(item.chartType);

      }
    },
    async loadAdminChart(type) {
  this.loadingChart = true;
  this.chart = [];

  // برای نوبت‌های خریداری شده و باطل شده امروز → تفکیک هر سالن
  if (type === "tickets" || type === "cancelled") {
    try {
      const res = await this.$persistClient(
        "get",
        `dashboard/today-tickets-by-salon?type=${type}`
      );

      const data = res.data.data || [];

      this.chart = data.map((item) => ({
        salon_name: item.salon_name,
        count: item.count,
      }));

      this.chartKey++;
    } catch (error) {
      console.error("loadAdminChart salon breakdown error:", error);
      this.chart = [];
    } finally {
      this.loadingChart = false;
    }
    return;
  }

  // سایر آیتم‌ها (رزرو بار / سالن صفر) → همان نمودار هفته گذشته
  const keyMap = {
    reserve: "last_reserve_requests",
    bazargah: "last_bazargah_requests",
  };

  const dashboardKey = keyMap[type];
  const data = dashboardKey
    ? this.adminDashboard[dashboardKey] || []
    : [];

  this.chart = data.map((item) => ({
    ...item,
    created_at: item.created_at
      ? this.$getJalaliDateFromDateTime(item.created_at)
      : "-",
  }));

  this.chartKey++;
  this.loadingChart = false;
},

    async fetchSalonChart(salonId) {

      if (!salonId) {

        this.chart = [];

        return;
      }


      this.loadingChart = true;


      try {

        const res = await this.$persistClient(

          "get",

          `requests/salon/${salonId}/last-week`

        );


        const data =
          res.data.data || [];

        this.chart = data.map((item) => ({

          ...item,

          date:
            item.date
              ? this.$getJalaliDate(
                  item.date
                )
              : "-",

        }));

        this.chartKey++;


      } catch (error) {

        console.error(
          "fetchSalonChart error:",
          error
        );


        this.chart = [];

      } finally {

        this.loadingChart = false;

      }
    },
    getItemValue(item) {

      if (!item) {
        return 0;
      }
      if (item.type === "salon") {

        return item.requests_count || 0;

      }

      const today =
        this.adminDashboard.today || {};


      const values = {

        tickets:
          today.ticket_count,

        cancelled:
          today.canceled_ticket_count,

        reserve:
          today.request_ticket_count,

        bazargah:
          today.request_ticket_bazargah_count,
      };


      return values[item.chartType] || 0;
    },

    lastWeekDate() {

      const lastWeek =
        this.adminDashboard.last_week;


      if (
        !lastWeek ||
        !lastWeek.start_at ||
        !lastWeek.end_at
      ) {

        return "-";

      }


      return `${this.$getJalaliDateNewFormat(
        lastWeek.start_at
      )} - ${this.$getJalaliDateNewFormat(
        lastWeek.end_at
      )}`;
    },

    // متدهای جدید بخش سالن‌ها
    fetchTopSalons() {
      this.$persistClient("get", "requests/top-salons").then((res) => {
        this.salons = res.data.data || [];
        // انتخاب اولین سالن به‌صورت پیش‌فرض
        if (this.salons.length > 0) {
          this.selectSalon(this.salons[0]);
        }
      });
    },
    selectSalon(salon) {
      this.selectedSalonId = salon.salon_id;
      this.selectedSalon = salon;
      this.fetchSalonLastWeek(salon.salon_id);
    },
    fetchSalonLastWeek(salonId) {
      this.$persistClient("get", `requests/salon/${salonId}/last-week`).then(
        (res) => {
          const data = res.data.data || [];
          this.salonChartData = data.map((item) => ({
            ...item,
            date: this.$getJalaliDateNewFormat(item.date),
          }));
          this.salonChartKey++;
        }
      );
    },
  },
};
</script>


<style scoped>


.dashboard-cards {
  margin-bottom: 10px;
}


.dashboard-card {

  cursor: pointer;

  height: 105px;

  padding: 12px;

  margin-bottom: 0;

  background: #fff;

  border: 2px solid transparent;

  border-radius: 6px;

  transition:
    all 0.2s ease;

  box-shadow:
    0 1px 4px rgba(0, 0, 0, 0.06);

}



.dashboard-card:hover {

  transform: translateY(-2px);

  box-shadow:
    0 4px 12px rgba(0, 0, 0, 0.10);

}



.dashboard-card.active-card {

  border-color: #1ab394;

  box-shadow:
    0 3px 12px rgba(26, 179, 148, 0.22);

}


.dashboard-card-content {

  height: 100%;

  display: flex;

  align-items: center;

  direction: rtl;

}

.dashboard-card-icon {

  width: 58px;

  min-width: 58px;

  height: 58px;

  margin-left: 12px;

  display: flex;

  align-items: center;

  justify-content: center;

  border-radius: 50%;

  background: #f4f8f7;

  color: #1ab394;

}


.dashboard-card-icon i {

  font-size: 25px;

}

.dashboard-card-info {

  flex: 1;

  min-width: 0;

  text-align: right;

  display: flex;

  flex-direction: column;

  justify-content: center;

}


.dashboard-card-title {

  display: block;

  font-size: 13px;

  font-weight: 600;

  color: #4b5563;

  white-space: nowrap;

  overflow: hidden;

  text-overflow: ellipsis;

  margin-bottom: 2px;

}

.dashboard-card-value {

  font-size: 30px;

  line-height: 1.1;

  font-weight: 800;

  color: #1f2937;

}

.dashboard-card-date {

  font-size: 10px;

  color: #9ca3af;

  margin-top: 2px;

}

.dashboard-card-subtitle {

  font-size: 10px;

  color: #9ca3af;

  margin-top: 2px;

}

.ibox {

  margin-top: 17px;

}

.chart-header {

  display: flex;

  align-items: center;

  justify-content: space-between;

}


.chart-title {

  margin: 0;

  font-size: 15px;

  font-weight: 700;

}


.chart-subtitle {

  color: #9ca3af;

}


.chart-loading {

  font-size: 12px;

  color: #999;

}

.empty-chart {

  min-height: 300px;

  display: flex;

  flex-direction: column;

  align-items: center;

  justify-content: center;

  color: #aaa;

}


.empty-chart i {

  font-size: 40px;

  margin-bottom: 10px;

}


.empty-chart p {

  margin: 0;

  font-size: 14px;

}

@media (max-width: 767px) {

  .dashboard-card {

    height: 95px;

  }


  .dashboard-card-icon {

    width: 48px;

    min-width: 48px;

    height: 48px;

    margin-left: 8px;

  }


  .dashboard-card-icon i {

    font-size: 20px;

  }


  .dashboard-card-title {

    font-size: 12px;

  }


  .dashboard-card-value {

    font-size: 25px;

  }

}

</style>